import React from 'react';
import { AlertTriangle, Phone, MessageSquare, X } from 'lucide-react';

export const CrisisModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="crisis-modal">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
        <div className="flex justify-between items-start mb-4">
          <div className="flex items-center space-x-3">
            <AlertTriangle className="w-8 h-8 text-[#D66D6D]" />
            <h2 className="text-2xl font-bold text-[#2D3A3A]" style={{ fontFamily: 'Nunito, sans-serif' }}>Crisis Resources</h2>
          </div>
          <button onClick={onClose} className="text-[#6B7C7C] hover:text-[#2D3A3A]" data-testid="crisis-modal-close">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <p className="text-[#2D3A3A]">
            If you're experiencing a mental health crisis or thinking about self-harm, please reach out immediately:
          </p>

          <div className="space-y-3">
            <a
              href="tel:788789882"
              className="flex items-center space-x-3 p-4 rounded-xl bg-[#D66D6D]/10 hover:bg-[#D66D6D]/20 transition-colors"
              data-testid="crisis-hotline-988"
            >
              <Phone className="w-6 h-6 text-[#D66D6D]" />
              <div>
                <div className="font-semibold text-[#2D3A3A]">Call 788789882</div>
                <div className="text-sm text-[#6B7C7C]">Suicide & Crisis Lifeline</div>
              </div>
            </a>

            <a
              href="sms:741741&body=HOME"
              className="flex items-center space-x-3 p-4 rounded-xl bg-[#79A8E0]/10 hover:bg-[#79A8E0]/20 transition-colors"
              data-testid="crisis-text-741741"
            >
              <MessageSquare className="w-6 h-6 text-[#79A8E0]" />
              <div>
                <div className="font-semibold text-[#2D3A3A]">Text HOME to 741741</div>
                <div className="text-sm text-[#6B7C7C]">Crisis Text Line</div>
              </div>
            </a>

            <a
              href="tel:112"
              className="flex items-center space-x-3 p-4 rounded-xl bg-[#E0C079]/10 hover:bg-[#E0C079]/20 transition-colors"
              data-testid="crisis-emergency-911"
            >
              <Phone className="w-6 h-6 text-[#E0C079]" />
              <div>
                <div className="font-semibold text-[#2D3A3A]">Call 112</div>
                <div className="text-sm text-[#6B7C7C]">Emergency Services</div>
              </div>
            </a>
          </div>

          <div className="mt-6 p-4 bg-[#8FB339]/10 rounded-xl">
            <p className="text-sm text-[#2D3A3A]">
              <strong>You're not alone.</strong> These services are free, confidential, and available 24/7.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};